module.exports = __webpack_public_path__ + "static/media/img_pizza.b80eae54.png";